import { DATADICTIONARY } from "../../constants/action-types";
const initialState = {
  dataDictionaryDataTable: [],
  dataDictionaryBatchData:null,
  dataDictionaryDetails: [],
  attributesData: [],
};

const DataDictionaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATADICTIONARY.GET_TABLE_DATA: {
      return Object.assign({}, state, {
        dataDictionaryDataTable: action.payload,
      });
    }

    case DATADICTIONARY.GET_BATCH_DATA: {
      return Object.assign({}, state, {
        dataDictionaryBatchData: action.payload,
      });
    }

    case DATADICTIONARY.GET_ATTRIBUTES: {
      return Object.assign({}, state, {
        attributesData: action.payload,
      });
    }

    case DATADICTIONARY.GET_DETAILS: {
      return Object.assign({}, state, {
        dataDictionaryDetails: action.payload,
      });
    }

    default:
      return state;
  }
};

export default DataDictionaryReducer;
